import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  return <header className="mx-auto max-w-narrow text-center" data-id="element-195" data-mp="3f2wxvnuzz3xr">
      {eyebrow && <p className={`text-[0.7rem] font-bold uppercase tracking-[0.2em] ${tone === 'dark' ? 'text-gold-300' : 'text-gold-700'}`} data-id="element-196" data-mp="3k0yfe4cryv74">
          {eyebrow}
        </p>}
      <h2 className={`mt-4 font-display text-[2.1rem] font-extrabold leading-[1.12] tracking-tight md:text-[2.9rem] ${tone === 'dark' ? 'text-white' : 'text-plum-700'}`} data-id="element-197" data-mp="gix4fmc0h4cq">
        {title}
      </h2>
      {intro && <div className={`mx-auto mt-5 max-w-2xl space-y-2 text-lg leading-relaxed ${tone === 'dark' ? 'text-plum-200' : 'text-muted'}`} data-id="element-198" data-mp="uippp24rqsdb">
          {intro}
        </div>}
    </header>;
}